// Copyright (C) 2020-2025 Skylark Drones

import apiInstance from '@/config'

export function getCompanies(q = null, limit = 20, pageNo = 1) {
  const config = { params: { limit, page: pageNo } }
  if (q) config.params.q = q
  return apiInstance.http.get('/company', config)
}

export function getCompany(id) {
  return apiInstance.http.get(`/company/${id}`)
}

export function updateCompany(id, etag, payload) {
  return apiInstance.http.patch(`/company/${id}`, payload, {
    headers: { 'If-Match': etag }
  })
}

export function deleteCompany(id) {
  return apiInstance.http.delete(`/company/${id}`)
}

export function getCompanyMembers(id, options) {
  return apiInstance.http.get(`/company/${id}/members`, { params: options })
}

/**
 *
 * @param {String} id Company id
 * @param {Object} options Options to pass as request query params
 * @param {keyof InviteStatus} options.status Option to filter invites by status
 * @returns
 */
export function getCompanyInvites(id, options) {
  if (!id) {
    throw Error(`Invalid company id (${id}) passed to getCompanyInvites`)
  }

  return apiInstance.http.get(`/company/${id}/invites`, { params: options })
}

/**
 *
 * @param {String} id Id of the company
 * @param {Object} payload Data to to post invite
 * @param {String} payload.email Email of the user to send invite to
 * @param {'member', 'admin', 'owner'} payload.role Role to assign the the invited user
 * @returns
 */
export function postCompanyInvite(id, payload) {
  if (!id) {
    throw Error(`Invalid company id (${id}) passed to postCompanyInvite`)
  }

  return apiInstance.http.post(`/company/${id}/invites`, payload)
}

export function createCompany(payload) {
  return apiInstance.http.post('/company', payload)
}

/**
 *
 * @param {String} id Id of the company
 * @returns {Promise<{binding_code: String}>} Response payload
 */
export function generateCompanyBindingCode(id) {
  return apiInstance.http.post(`/company/${id}/generate_bind_code`)
}

/**
 *
 * @param {String} companyId
 * @param {Object} payload
 * @param {string} payload.hardware_id serial number of the drone
 * @param {string} payload.asset asset id of the drone
 * @returns {Promise<{binding_code: String}>} Response payload
 */
export function linkDrone(companyId, payload) {
  return apiInstance.http.post(`/company/${companyId}/drones/link`, payload)
}

/**
 * @param {String} companyId
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export function fetchLinkedDrones(companyId) {
  return apiInstance.http.get(`/company/${companyId}/drones/link`)
}

/**
 * @param {String} companyId
 * @param {String} linkedDroneId
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export function unlinkCompanyDrone(companyId, linkedDroneId) {
  return apiInstance.http.delete(
    `/company/${companyId}/drones/link/${linkedDroneId}`
  )
}

/**
 * Get company subscription details
 *
 * @param {String} companyId
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export function getCompanySubscription(companyId) {
  return apiInstance.http.get(`/company/${companyId}/subscription`)
}

export function updateCompanyFcl(id, etag, payload) {
  return apiInstance.http.patch(`/company/${id}/fcl`, payload, {
    headers: { 'If-Match': etag }
  })
}
